import {
  IconDefinition,
  IconFamily,
} from '@fortawesome/fontawesome-common-types';
import styledIcon, { IconStyles } from './styledIcon';

export const faArrowRotateRight = arrowRotateRight('classic', 'thin');
export const falArrowRotateRight = arrowRotateRight('classic', 'light');
export const fatArrowRotateRight = arrowRotateRight('classic', 'thin');
export const fadArrowRotateRight = arrowRotateRight('duotone', 'thin');
export const fasArrowRotateRight = arrowRotateRight('classic', 'solid');
export const farArrowRotateRight = arrowRotateRight('classic', 'regular');

export default function arrowRotateRight(
  family: IconFamily,
  style: IconStyles
): IconDefinition {
  return styledIcon(
    family,
    style,
    'arrow-rotate-right',
    512, // width
    512, // height
    'f01e', // unicode
    [
      [
        'classic',
        'solid',
        'M386.3 160L336 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160z',
      ],
      [
        'classic',
        'regular',
        'M472 224c13.3 0 24-10.7 24-24l0-144c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80.1-20-23.5C387 63.4 325.1 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c50.4 0 97-16.7 134.4-44.8c10.6-8 12.7-23 4.8-33.6s-23-12.7-33.6-4.8C332.2 418.9 295.7 432 256 432c-97.2 0-176-78.8-176-176s78.8-176 176-176c54.3 0 102.9 24.6 135.2 63.4l.1 .2s0 0 0 0L418.9 176 328 176c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0z',
      ],
      [
        'classic',
        'light',
        'M464 192c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 92.6C408.8 75.5 337.5 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c79.9 0 150-41.8 189.7-104.8c6.6-10.4-1.4-23.2-13.7-23.2c-6 0-11.4 3.2-14.7 8.2C383.1 413 323.6 448 256 448C150 448 64 362 64 256S150 64 256 64c71.1 0 133.1 38.6 166.3 96L336 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0z',
      ],
      [
        'classic',
        'thin',
        'M384.1 419.9c-90.5 70.7-221.2 54.7-292-35.8s-54.7-221.2 35.8-292c90.5-70.7 221.2-54.7 291.9 35.8L456 176l-128 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l144 0c4.4 0 8-3.6 8-8l0-144c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 120-31.4-41.8s0 0 0 0l-.1-.1C356.4 20.6 215.6 3.3 118.1 79.5S3.3 296.4 79.5 393.9s216.9 114.8 314.4 38.6c24.7-19.3 44.2-42.7 58.4-68.6c2.1-3.9 .7-8.7-3.2-10.9s-8.7-.7-10.9 3.2c-13.2 24-31.3 45.7-54.3 63.7z',
      ],
      [
        'duotone',
        'thin',
        [
          'M92.1 384.1c-70.7-90.5-54.7-221.2 35.8-292c90.5-70.7 221.2-54.7 291.9 35.8L456 176l-128 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l142.7 0c6 20.3 9.3 41.8 9.3 64c0 38.9-9.9 75.6-27.4 107.5c1.8-3.8 .3-8.3-3.4-10.4c-3.9-2.1-8.7-.7-10.9 3.2c-13.2 24-31.3 45.7-54.3 63.7c-90.5 70.7-221.2 54.7-292-35.8z',
          'M384.1 419.9c-90.5 70.7-221.2 54.7-292-35.8s-54.7-221.2 35.8-292c90.5-70.7 221.2-54.7 291.9 35.8L456 176l-128 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l144 0c4.4 0 8-3.6 8-8l0-144c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 120-31.4-41.8s0 0 0 0l-.1-.1C356.4 20.6 215.6 3.3 118.1 79.5S3.3 296.4 79.5 393.9s216.9 114.8 314.4 38.6c24.7-19.3 44.2-42.7 58.4-68.6c2.1-3.9 .7-8.7-3.2-10.9s-8.7-.7-10.9 3.2c-13.2 24-31.3 45.7-54.3 63.7z',
        ],
      ],
    ]
  );
}
